/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function AnchorSimple(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M224.001,111.99707h-24a8,8,0,0,0,0,16h15.63964A88.14248,88.14248,0,0,1,136.001,207.626V94.98437a32,32,0,1,0-16,0V207.626a88.1425,88.1425,0,0,1-79.63965-79.62891H56.001a8,8,0,0,0,0-16h-24a8.00039,8.00039,0,0,0-8,8,104,104,0,0,0,208,0A8.00039,8.00039,0,0,0,224.001,111.99707Zm-112-48a16,16,0,1,1,16,16A16.01833,16.01833,0,0,1,112.001,63.99707Z" />
    </Svg>
  );
}

export default AnchorSimple;
